import React, { useState } from 'react';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';

import ConversationDetails from '../../../../../components/Conversation/ConversationDetails';
import ModalConfirmation from '../../../../../components/Modal/ConfirmationModal';
import { PhoneCell } from '../../../../../components/FlexTable/components/cells/phone';
import FlexTable from '../../../../../components/FlexTable';
import WhatsappBlockListService from '../../../services';

import {
  icon_column_style,
  individual_icon_header_style
} from '../../../../../assets/styles/table_custom_style';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';

export const ActiveWhatsappBlockListTable = ({
  handleSearch,
  data,
  setSortConfig,
  sortConfig,
  templates = []
}) => {
  const history = useHistory();
  const [openModalConfirmation, setOpenModalConfirmation] = useState(false);
  const [blockedNumberId, setBlockedNumberId] = useState(null);

  const editBlockedNumber = (row) => {
    history.push(`/admin/chat/active-whatsapp-block-list/form/${row.id}`);
  };

  const controlDeleteBlockedNumber = (id) => {
    setBlockedNumberId(id);
    setOpenModalConfirmation(true);
  };

  const unBlockNumber = async (id) => {
    try {
      await WhatsappBlockListService.delete(id);
      const message = 'Número desbloqueado com sucesso';
      toast.success(message, {
        autoClose: 3000,
        closeOnClick: true
      });
    } catch (err) {
      toast.error(' Erro ao desbloquear o número', {
        autoClose: 3000,
        closeOnClick: true
      });
    } finally {
      handleSearch();
      setOpenModalConfirmation(false);
    }
  };

  const createDynamicColumns = () => {
    const columns = [];

    columns.push(
      {
        dataField: 'telephone',
        text: 'Telefone',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, row) => <PhoneCell phone={row.telephone} ddi={row.ddi} />
      },
      {
        dataField: 'reason',
        text: 'Motivo do bloqueio',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, { reason }) => reason
      },
      {
        dataField: 'userName',
        text: 'Criado por',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, { userName }) => userName
      },
      {
        dataField: 'templateId',
        text: 'Template',
        style: individual_column_style,
        headerStyle: { ...individual_header_style, cursor: 'pointer' },
        formatter: (_, { templateId }) => {
          const template = templates.find((t) => t.id === templateId);
          return template ? template.name : '';
        }
      }
    );

    columns.push({
      dataField: 'details',
      text: 'Conversa',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return (
          <>
            <ConversationDetails
              conversationData={null}
              getDataOnModalOpen={true}
              disabled={!row.chatId}
              id={row.id}
              chatIdToBeSearched={row.chatId}
            />
          </>
        );
      }
    });

    columns.push({
      dataField: 'edit',
      text: 'Editar',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return (
          <>
            <Button
              size="sm"
              color="info"
              onClick={() => editBlockedNumber(row)}
            >
              <li className="fas fa-user-edit"></li>
            </Button>
          </>
        );
      }
    });

    columns.push({
      dataField: 'delete',
      text: 'Excluir',
      style: icon_column_style,
      headerStyle: individual_icon_header_style,
      formatter: (_, row) => {
        return (
          <Button
            size="sm"
            color="danger"
            onClick={() => controlDeleteBlockedNumber(row.id)}
          >
            <li className="fas fa-trash"></li>
          </Button>
        );
      }
    });

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  return (
    <>
      <ToolkitProvider
        data={data || []}
        keyField="id"
        columns={dynamicFunctionColumns}
      >
        {(props) => (
          <div className="py-4 table-responsive">
            <FlexTable
              {...props.baseProps}
              entityName="activeWhatsappBlock"
              setSortConfig={setSortConfig}
              sortConfig={sortConfig}
            />
          </div>
        )}
      </ToolkitProvider>
      <ModalConfirmation
        isModalOpen={openModalConfirmation}
        onModalToggle={setOpenModalConfirmation}
        unmountOnClose={true}
        idResource={blockedNumberId}
        deleteResource={unBlockNumber}
        message={'Tem certeza que desbloquear este número?'}
      />
    </>
  );
};
